module.exports = __webpack_public_path__ + "static/media/database.cd3bb54c.svg";